import useSWR, { type SWRConfiguration } from "swr";
import type { RegistersGeoJsonResponse } from "./type";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import { config } from "@/config";
import { isEmpty } from "@utils/formatters";
import type { RegistersFilters } from "../list/type";

async function getRegistersGeoJson(
  query?: RegistersFilters,
): Promise<RegistersGeoJsonResponse> {
  const params = new URLSearchParams();

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (isEmpty(value)) return;

      params.append(key, String(value));
    });
  }

  let url = apiPaths.registers.getGeoJson;

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<RegistersGeoJsonResponse>(url);

  return response.data;
}

export function useGetRegistersGeoJson(
  query?: RegistersFilters,
  options?: SWRConfiguration & { enabled?: boolean },
) {
  const enabled = options?.enabled ?? true;

  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    revalidateOnFocus: false,
    ...options,
  };

  return useSWR(
    enabled ? [`fetch-registers-geojson`, JSON.stringify(query ?? {})] : null,
    () => getRegistersGeoJson(query ?? {}),
    mergedOptions,
  );
}
